
'use strict';

(function () {
  if (!customElements.get('featured-blog')) {
    class FeaturedBlog extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.slider = this.querySelector('.swiper');
        this.handleResize = debounce(this.handleResize.bind(this), 200);
      }

      connectedCallback() {
        this.initSwiper();
        window.addEventListener('resize', this.handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        this.destroySwiper();
      }


      initSwiper = () => {
        this.slider = this.querySelector('.swiper');
        const scrollbarEl = this.querySelector('.swiper-scrollbar');

        if (!this.slider || window.innerWidth >= 990 || this.swiper) return;
        const isMobile = window.innerWidth < 750;

				let {
					slidesLength,
					spaceBetween = 10,
					spaceBetweenMd = 16,
					slidesPerView = 1.1,
					slidesPerViewLg,
				} = this.dataset;

				slidesLength = +slidesLength;

				const slidesPerViewBase = slidesLength < +slidesPerView ? +slidesLength : +slidesPerView;
				slidesPerViewLg = +slidesPerViewLg;

				let slidesPerViewMd =  (slidesPerViewBase + slidesPerViewLg) / 2;
				slidesPerViewMd =  slidesLength < slidesPerViewMd ? slidesLength : slidesPerViewMd;

        const mobileSpaceBetween = Number(spaceBetween) || 10;
        const tabletSpaceBetween = Number(spaceBetweenMd) || mobileSpaceBetween;

				const swiperParams = {
					speed: 300,
					slidesPerView: isMobile ? 'auto' : slidesPerViewBase,
					spaceBetween: 10,
          ...(scrollbarEl
            ? {
                scrollbar: {
                  el: scrollbarEl,
                  draggable: true,
                },
              }
            : {}),
          breakpoints: {
            750: {
              slidesPerView: slidesPerViewMd,
              spaceBetween: tabletSpaceBetween,
            },
          },
				}

        this.swiper = new Swiper(this.slider, {
          ...swiperParams,
        });
        this.swiper.update();
      };

      destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      handleResize() {
        if (window.innerWidth < 990) {
          this.initSwiper();
        } else {
          this.destroySwiper();
        }
      }
    }

    customElements.define('featured-blog', FeaturedBlog);
  }
})();
